
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class VTooltip extends Vue {
  private open = false;
}
